import { get } from "../methods";
function getUserCompanyLimit_default(headers = {}) {
  return get({
    url: "api/user/company/limit",
    headers
  });
}
export {
  getUserCompanyLimit_default as default
};
